import { render, staticRenderFns } from "./MyAccountCollectionsShared.vue?vue&type=template&id=7ac8e01a"
import script from "./MyAccountCollectionsShared.vue?vue&type=script&lang=js"
export * from "./MyAccountCollectionsShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports